export const iconFontAwesomeHouseholdSpoon = (
	<i className="fa-solid fa-spoon"></i>
);
